"use client";

import { useState } from "react";
import { Calendar, ClipboardList, Flower2, Gem, Heart, LayoutGrid, Leaf, Mail, MapPin, Sparkles, Users, Wallet } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tabs = [{
  id: "full-service",
  label: "Portal Nasional"
}, {
  id: "partial",
  label: "Zona PP"
}, {
  id: "month-of",
  label: "Layanan Publik"
}];
const fullServiceFeatures = [{
  icon: Wallet,
  title: "Berita Utama",
  description: "Liputan mendalam mengenai isu nasional dengan akurasi dan integritas tinggi."
}, {
  icon: Users,
  title: "Jaringan Kontributor",
  description: "Kolaborasi dengan jurnalis profesional di seluruh penjuru nusantara."
}, {
  icon: LayoutGrid,
  title: "Kanal Terstruktur",
  description: "Navigasi berita yang rapi mulai dari politik, ekonomi, hingga gaya hidup."
}, {
  icon: ClipboardList,
  title: "Verifikasi Fakta",
  description: "Proses kurasi ketat untuk memastikan setiap informasi bebas dari hoaks."
}, {
  icon: Sparkles,
  title: "Visual Modern",
  description: "Penyajian konten dengan grafis dan tata letak yang bersih serta profesional."
}, {
  icon: MapPin,
  title: "Liputan Daerah",
  description: "Akses berita dari 27 wilayah dengan fokus pada perkembangan lokal."
}, {
  icon: Flower2,
  title: "Klarifikasi Resmi",
  description: "Ruang khusus untuk hak jawab dan pelurusan informasi bagi publik."
}, {
  icon: Mail,
  title: "Newsletter Harian",
  description: "Ringkasan berita terpenting yang dikirimkan langsung ke perangkat Anda."
}, {
  icon: Calendar,
  title: "Agenda Nasional",
  description: "Kalender peristiwa penting yang akan memengaruhi kebijakan publik."
}, {
  icon: Heart,
  title: "Aspirasi Rakyat",
  description: "Wadah bagi suara masyarakat untuk didengar oleh para pemangku kebijakan."
}, {
  icon: Gem,
  title: "Konten Eksklusif",
  description: "Investigasi mendalam dan opini dari pakar di bidang masing-masing."
}, {
  icon: Leaf,
  title: "Arsip Digital",
  description: "Penyimpanan data berita yang mudah diakses untuk referensi masa depan."
}];
const partialFeatures = [{
  icon: Wallet,
  title: "Profil Organisasi",
  description: "Informasi lengkap mengenai sejarah dan visi Pemuda Pancasila."
}, {
  icon: Users,
  title: "Struktur Komando",
  description: "Hierarki kepemimpinan yang jelas dari tingkat pusat hingga basis."
}, {
  icon: LayoutGrid,
  title: "Unit Fungsional",
  description: "Pembagian kerja yang efektif untuk pemberdayaan anggota."
}, {
  icon: ClipboardList,
  title: "Mandat Konstitusi",
  description: "Pedoman organisasi yang berlandaskan pada nilai-nilai Pancasila."
}, {
  icon: Sparkles,
  title: "Warta Zona PP",
  description: "Kumpulan berita dan kegiatan terbaru dari seluruh kader di Indonesia."
}, {
  icon: Calendar,
  title: "Kegiatan Sosial",
  description: "Dokumentasi bakti sosial dan kontribusi nyata bagi masyarakat."
}, {
  icon: Heart,
  title: "Solidaritas Anggota",
  description: "Program kesejahteraan dan dukungan bagi seluruh keluarga besar PP."
}, {
  icon: Mail,
  title: "Pendaftaran Online",
  description: "Sistem digital untuk mempermudah administrasi keanggotaan baru."
}];
const monthOfFeatures = [{
  icon: ClipboardList,
  title: "Kirim Berita",
  description: "Formulir kontribusi bagi warga untuk melaporkan kejadian di sekitar."
}, {
  icon: Users,
  title: "Layanan Kerjasama",
  description: "Peluang kemitraan strategis untuk iklan dan publikasi media."
}, {
  icon: LayoutGrid,
  title: "Streaming Live",
  description: "Siaran langsung peristiwa penting secara real-time dan interaktif."
}, {
  icon: Calendar,
  title: "Jadwal Redaksi",
  description: "Transparansi waktu tayang untuk setiap rubrik dan program khusus."
}, {
  icon: Heart,
  title: "Pusat Bantuan",
  description: "Layanan pelanggan yang responsif untuk kendala teknis dan konten."
}, {
  icon: Sparkles,
  title: "Optimasi Mobile",
  description: "Pengalaman membaca yang nyaman di semua jenis perangkat seluler."
}, {
  icon: Mail,
  title: "Kontak Redaksi",
  description: "Saluran komunikasi langsung dengan tim editor ABADI.NEWS."
}, {
  icon: Gem,
  title: "Keamanan Data",
  description: "Perlindungan privasi pengguna sesuai dengan standar hukum siber."
}];
const featureMap: Record<string, typeof fullServiceFeatures> = {
  "full-service": fullServiceFeatures,
  partial: partialFeatures,
  "month-of": monthOfFeatures
};
export default function Informationdeliveryguidelines() {
  const [activeTab, setActiveTab] = useState("full-service");
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const activeFeatures = featureMap[activeTab];
  return;
}